"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.secondsToString = exports.formatDataValue = exports.formatMeasurement = exports.dataTypeForProp = exports.unitsForProp = exports.unitsForDataType = void 0;

var _ = require(".");

var _number = require("./number");

/**
 * @ignore
 */
var _units = {
  imperial: {
    temp: '&deg;F',
    speed: ' mph',
    distance: ' mi',
    height: ' ft',
    pressure: ' in',
    percent: '%',
    precip: '"',
    rain: '"',
    snow: '"',
    text: '',
    degree: '&deg;'
  },
  metric: {
    temp: '&deg;C',
    speed: ' km/h',
    distance: ' km',
    height: ' m',
    pressure: ' mb',
    percent: '%',
    precip: ' mm',
    rain: ' mm',
    snow: ' cm',
    phrase: 'met',
    degree: '&deg;'
  }
};
/**
 * @ignore
 */

var patterns = {
  temp: '(temp|dewpoint|dewpt|feelslike|windchill|heatindex)',
  speed: '(speed|gust|wind)',
  distance: '(visibility|distance)',
  height: '(ceiling|elev|elevation|height|ht)',
  pressure: '(pressure|altimeter)',
  rain: '(precip|rain|prcp)',
  snow: '(snow|snowdepth|hail)',
  text: '(phrase)',
  percent: '(rh|humid|pop|prob|sky|skycover)'
};

var unitsForDataType = function (type, isMetric) {
  if (isMetric === void 0) {
    isMetric = false;
  }

  if (isMetric) {
    return _units.metric[type] || '';
  }

  return _units.imperial[type] || '';
};

exports.unitsForDataType = unitsForDataType;

var unitsForProp = function (prop, isMetric) {
  var type = isMetric ? 'metric' : 'imperial';
  prop = prop.toLowerCase();
  var units;
  Object.keys(patterns).forEach(function (key) {
    var re = new RegExp(patterns[key], 'i');

    if (prop.match(re)) {
      units = (0, _.get)(_units, type + "." + key);
    }
  });
  return units;
};

exports.unitsForProp = unitsForProp;

var dataTypeForProp = function (prop) {
  var result;
  prop = (prop || '').toLowerCase().replace(/\s/g, '');

  if (undefined !== patterns[prop]) {
    return prop;
  }

  if (/prob(ability)?/.test(prop)) {
    return 'percent';
  }

  Object.keys(patterns).forEach(function (key) {
    var re = new RegExp(patterns[key], 'i');

    if (re.test(prop)) {
      result = key;
    }
  });
  return result;
};

exports.dataTypeForProp = dataTypeForProp;

var formatMeasurement = function (value, prop, isMetric, includeUnits, defaultValue, unitsTemplate) {
  if (isMetric === void 0) {
    isMetric = false;
  }

  if (includeUnits === void 0) {
    includeUnits = false;
  }

  if (defaultValue === void 0) {
    defaultValue = '--';
  }

  if (unitsTemplate === void 0) {
    unitsTemplate = null;
  }

  if ((0, _.isset)(value) === false) {
    return defaultValue;
  }

  var type = dataTypeForProp(prop);

  if (!type) {
    return "" + value;
  }

  var decimals = 0;
  var units = '';
  var spacer = ' ';

  if (type === 'temp') {
    spacer = '';
  } else if (type === 'pressure') {
    decimals = isMetric ? 0 : 2;
  } else if (type === 'rain') {
    decimals = isMetric ? 1 : 2;
  } else if (type === 'snow') {
    decimals = 1;
  } else if (type === 'distance') {
    decimals = 2;
  }

  if (decimals > 0) {
    value = parseFloat(value).toFixed(decimals);
  } else {
    value = Math.round(value);
  }

  if (includeUnits) {
    units = unitsForDataType(type, isMetric);

    if ((0, _.isset)(unitsTemplate)) {
      units = unitsTemplate.replace(/{{units}}/, units);
    }
  }

  return "" + (0, _number.formatNumber)(value, decimals) + spacer + units;
};

exports.formatMeasurement = formatMeasurement;

var formatDataValue = function (data, key, metricKey, isMetric) {
  if (metricKey === void 0) {
    metricKey = null;
  }

  if (isMetric === void 0) {
    isMetric = false;
  }

  var prop = isMetric ? metricKey || key : key;
  return formatMeasurement((0, _.get)(data, prop), prop, isMetric, true, 'N/A', '<span class="units">{{units}}</span>');
};

exports.formatDataValue = formatDataValue;

var secondsToString = function (value, includeSeconds) {
  if (includeSeconds === void 0) {
    includeSeconds = false;
  }

  var result = [];
  var hours = Math.floor(value / 3600);
  var minutes = Math.floor((value - hours * 3600) / 60);
  var seconds = Math.floor(value - hours * 3600 - minutes * 60);

  if (hours > 0) {
    result.push(hours + " hr");
  }

  if (minutes > 0) {
    result.push(minutes + " min");
  }

  if (includeSeconds && seconds > 0) {
    result.push(seconds + " sec");
  }

  return result.join(', ');
};

exports.secondsToString = secondsToString;